import React, { useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { PlaceHolderHouseUrl } from '../../components/Svg'
import { Arrows } from './Arrows'
import { clickType } from '.'
import { useResponsive } from '../Hooks'
import { Spinner } from '../Svg'

export const PhotoCarouselPreview = ({ isLoading, photo, onClick }) => {
  const { isDesktop } = useResponsive()
  const touchStartX = useRef(null)

  const getDotRange = useCallback(() => {
    return [...Array(5).keys()]
  }, [])

  const handleNextClick = useCallback((e) => {
    if (isLoading) {return}
    e.preventDefault()
    onClick(clickType.FORWARD)
  }, [onClick, isLoading])

  const handlePrevClick = useCallback((e) => {
    if (isLoading) {return}
    e.preventDefault()
    onClick(clickType.BACK)
  }, [onClick, isLoading])

    const onTouchStart = useCallback(e => {
      touchStartX.current = e.touches[0].clientX
    }, [touchStartX])
  
    const onTouchEnd = useCallback(e => {
      const deltaX = touchStartX.current - e.changedTouches[0].clientX
      if (deltaX > 50) {onClick(clickType.FORWARD)}
      if (deltaX < -50) {onClick(clickType.BACK)}
    }, [touchStartX, onClick])
  
  return (  
    <div
      className='PhotoCarousel'
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      <div className='PhotoCarousel-imageContainer'>
        <div className='PhotoCarousel-imageWrapper'>
          <img
              src={photo?.webp ?? PlaceHolderHouseUrl}
              alt={photo?.webp || ''}
              loading='lazy'
              className='PhotoCarousel-image'
              data-sprinkle='replace-broken-image'
              data-replace-broken-image-url={PlaceHolderHouseUrl}
            />
            {isLoading && (
            <div className='PhotoCarousel-loadingOverlay'>
              <Spinner className='PhotoCarousel-spinner' />
            </div>
          )}
        </div>
        {isDesktop && <Arrows onNextClick={handleNextClick} onPreviusClick={handlePrevClick} />}
      </div>

      <div className={cn('PhotoCarousel-dots', { 'PhotoCarousel-dots--zIndex2': isLoading })}>
        <div className='PhotoCarousel-dotsWrapper'>
        {getDotRange().map(i => (
          <span
            key={i}
            className={cn('PhotoCarousel-dot', { 'PhotoCarousel-dot--activeDot': i === 0 })}
          />
        ))}
        </div>
      </div>
    </div>
  )
}

PhotoCarouselPreview.propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.number.isRequired,
    webp: PropTypes.string.isRequired,
    jpeg: PropTypes.string.isRequired
  }),
  onClick: PropTypes.func,
  isLoading: PropTypes.bool
}
